// casesData.js
export const CASES = [
  {
    id: "case-1",
    slug: "lt-construction",
    title: "How Sprout builds stronger construction among L&T employees",
    excerpt:
      "L&T is a prominent Indian Multinational company with interests in engineering, construction, manufacturing, and technology. L & T Construction, a division of Larsen & Toubro is the largest construction organization in India and among the top 30 contractors globally.",
    hero: "/images/case-lt-hero.jpg", // optional hero image path (put in public/images)
    pdfUrl: "/case-studies/LT-Case-Study.pdf", // put the uploaded PDF into public/case-studies/
    // short HTML-friendly content — you can expand or keep as fallback
    contentHtml: `
      <p><strong>About the company</strong>: L&T Construction is the largest construction organization in India and among the top 30 contractors globally.</p>
      <p><strong>Hurdles faced</strong>: Diverse geographical & linguistic backgrounds created communication challenges among employees.</p>
      <p><strong>Approach</strong>: Sprout delivered project-based, practical upskilling, language & communication assessments and targeted modules.</p>
      <p><strong>Outcomes</strong>: Improved communication, promotions, cross-functional integration and measurable productivity improvements.</p>
    `,
    // meta extracted from the uploaded PDF pages for the preview (we cite the PDF above)
    pdfSummary: {
      pagesMentioned: [1,2,3],
      bullets: [
        "Page 1 — Title, hero image and summary headline.",
        "Page 2 — About company and hurdles faced (communication challenges due to diverse workforce).",
        "Page 3 — Outcomes: career acceleration, improved communication, leadership & promotion evidence."
      ]
    }
  },

  {
    id: "case-2",
    slug: "chennai-motorcycle",
    title: "How Sprout’s program enhanced a Leading Chennai Based Motorcycle Company’s Productivity",
    excerpt:
      "An Indian international motorcycle manufacturing company based in Chennai achieved a remarkable increase in productivity through the implementation of Sprout Knowledge Solutions English communication program.",
    hero: "/images/case-moto-hero.jpg",
    pdfUrl: "/case-studies/Royal-Enfield-Case-Study-4.pdf", 
    contentHtml: `<p>Case summary placeholder — replace with content or upload PDF.</p>`
  },
];